// import { Index as DIndex } from "./dekstop/Index"
import { Index as MIndex } from "./mobile/Index"
import { VM } from "../../../core/VM"

const view = VM()

export const BillOut = () => { 
    return (
        view === '' ? 
            // DESKTOP
            // <DIndex/>
            <></>
        : ( view === "/devices/mobile" || view === "/devices/tablet" ) &&
            // MOBILE
            <MIndex/>
    )
}
